import Login from '@/modules/auth/views/Login';
import Logout from '@/modules/auth/views/Logout';
// import Register from '@/modules/auth/views/Register';
// import Recover from '@/modules/auth/views/Recover';
// import VerifyOTP from '@/modules/auth/views/VerifyOTP';
// import Oauth2view from '@/modules/auth/views/Oauth2View';

export default [

	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			layout: 'login'			
		}
	},
	{
		path: '/logout',
		name: 'logout',
		component: Logout,
		meta: {
			requiresAuth: true,
		},
	},
	/*{
		path: '/register',
		name: 'register',
		component: Register,
		props: (route) => ({ hash: route.query.hash, email: route.query.email }),
		meta: {
			layout: 'login'
		}
	},
	{
		path: '/recover',
		name: 'recover',
		component: Recover,
		meta: {
			layout: 'login'
		}
	},
	{
		path: '/verify',
		name: 'otpVerifier',
		component: VerifyOTP,
		meta: {
			layout: 'login'
		}
	},
	{
		path: '/oauth2check',
		name: 'oauth2view',
		component: Oauth2view,                
		meta: { layout: 'login' }
	}*/

]
